import React, { useState } from "react";
import { ethers } from "ethers";
import "./OwnerDashboard.css";

const OwnerDashboard = ({ contract, account }) => {
  const [newOwner, setNewOwner] = useState("");
  const [tokenAddress, setTokenAddress] = useState("");
  const [withdrawAmount, setWithdrawAmount] = useState("");
  const [rewardRates, setRewardRates] = useState({
    rewardRate12Months: "",
    rewardRate6Months: "",
    rewardRate3Months: "",
    rewardRate1Month: "",
  });
  const [penaltyRate, setPenaltyRate] = useState("");
  const [balance, setBalance] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setRewardRates((prev) => ({ ...prev, [name]: value }));
  };

  const handleNewOwnerChange = (e) => setNewOwner(e.target.value);
  const handleTokenAddressChange = (e) => setTokenAddress(e.target.value);
  const handleWithdrawAmountChange = (e) => setWithdrawAmount(e.target.value);
  const handlePenaltyRateChange = (e) => setPenaltyRate(e.target.value);

  const updateRewardRates = async () => {
    try {
      const tx = await contract.updateRewardRates(
        ethers.utils.parseUnits(rewardRates.rewardRate12Months, 18),
        ethers.utils.parseUnits(rewardRates.rewardRate6Months, 18),
        ethers.utils.parseUnits(rewardRates.rewardRate3Months, 18),
        ethers.utils.parseUnits(rewardRates.rewardRate1Month, 18)
      );
      await tx.wait();
      alert("Reward rates updated successfully!");
    } catch (error) {
      console.error("Failed to update reward rates:", error);
      alert("Failed to update reward rates. Please try again.");
    }
  };

  const updatePenaltyRate = async () => {
    try {
      const tx = await contract.updatePenaltyRate(
        ethers.utils.parseUnits(penaltyRate, 18)
      );
      await tx.wait();
      alert("Penalty rate updated successfully!");
    } catch (error) {
      console.error("Failed to update penalty rate:", error);
      alert("Failed to update penalty rate. Please try again.");
    }
  };

  const updateOwner = async () => {
    try {
      const tx = await contract.updateOwner(newOwner);
      await tx.wait();
      alert("Owner updated successfully!");
    } catch (error) {
      console.error("Failed to update owner:", error);
      alert("Failed to update owner. Please try again.");
    }
  };

  const withdrawTokens = async () => {
    try {
      const tx = await contract.withdrawTokens(
        tokenAddress,
        ethers.utils.parseUnits(withdrawAmount, 18)
      );
      await tx.wait();
      alert("Tokens withdrawn successfully!");
    } catch (error) {
      console.error("Failed to withdraw tokens:", error);
      alert("Failed to withdraw tokens. Please try again.");
    }
  };

  const pauseContract = async () => {
    try {
      const tx = await contract.pause();
      await tx.wait();
      alert("Contract paused successfully!");
    } catch (error) {
      console.error("Failed to pause contract:", error);
      alert("Failed to pause contract. Please try again.");
    }
  };

  const unpauseContract = async () => {
    try {
      const tx = await contract.unpause();
      await tx.wait();
      alert("Contract unpaused successfully!");
    } catch (error) {
      console.error("Failed to unpause contract:", error);
      alert("Failed to unpause contract. Please try again.");
    }
  };

  const getBalance = async () => {
    try {
      const balanceWei = await contract.getContractTokenBalance();
      const balanceFormatted = ethers.utils.formatUnits(balanceWei, 18); // Assuming the token uses 18 decimal places
      setBalance(balanceFormatted);
    } catch (error) {
      console.error("Failed to fetch balance:", error);
      alert("Failed to fetch the balance. Please try again.");
    }
  };

  return (
    <div className="owner-dashboard">
      <div className="grid-container">
        <div className="form-group">
          <label>New Owner Address:</label>
          <input
            type="text"
            value={newOwner}
            onChange={handleNewOwnerChange}
            placeholder="New Owner Address"
          />
          <button className="owner-button" onClick={updateOwner}>
            Update Owner
          </button>
          <p>Balance: {balance}</p>
          <button onClick={getBalance} className="owner-button">
            Check Balance
          </button>
        </div>

        <div className="form-group">
          <label>Token Address:</label>
          <input
            type="text"
            value={tokenAddress}
            onChange={handleTokenAddressChange}
            placeholder="Token Address"
          />
          <label>Withdraw Amount:</label>
          <input
            type="text"
            value={withdrawAmount}
            onChange={handleWithdrawAmountChange}
            placeholder="Withdraw Amount"
          />
          <button className="owner-button" onClick={withdrawTokens}>
            Withdraw Tokens
          </button>
        </div>

        <div className="form-group">
          <div className="each-rate">
            <label>12 Months (%):</label>
            <input
              type="text"
              name="rewardRate12Months"
              value={rewardRates.rewardRate12Months}
              onChange={handleInputChange}
              placeholder="12 Months Reward Rate"
            />
          </div>
          <div className="each-rate">
            <label>6 Months (%):</label>
            <input
              type="text"
              name="rewardRate6Months"
              value={rewardRates.rewardRate6Months}
              onChange={handleInputChange}
              placeholder="6 Months Reward Rate"
            />
          </div>
          <div className="each-rate">
            <label>3 Months (%):</label>
            <input
              type="text"
              name="rewardRate3Months"
              value={rewardRates.rewardRate3Months}
              onChange={handleInputChange}
              placeholder="3 Months Reward Rate"
            />
          </div>
          <div className="each-rate">
            <label>1 Month (%):</label>
            <input
              type="text"
              name="rewardRate1Month"
              value={rewardRates.rewardRate1Month}
              onChange={handleInputChange}
              placeholder="1 Month Reward Rate"
            />
          </div>
          <button className="owner-button" onClick={updateRewardRates}>
            Update Reward Rates
          </button>
        </div>

        <div className="form-group">
          <label>Penalty Rate (%):</label>
          <input
            type="text"
            value={penaltyRate}
            onChange={handlePenaltyRateChange}
            placeholder="Penalty Rate"
          />
          <button className="owner-button" onClick={updatePenaltyRate}>
            Update Penalty Rate
          </button>
          <button className="owner-button" onClick={pauseContract}>
            Pause Contract
          </button>
          <button className="owner-button" onClick={unpauseContract}>
            Unpause Contract
          </button>
        </div>
      </div>
    </div>
  );
};

export default OwnerDashboard;
